export const Rectangle = ({ isFilled }: { isFilled?: boolean }) => {
  return (
    <svg
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill={isFilled ? 'black' : 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.25" y="0.25" width="15.5" height="21.5" stroke="black" strokeWidth="0.5" />
    </svg>
  );
};
